module.exports = __webpack_public_path__ + "static/media/greyGo.4d3375e2.svg";